var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('formula-head',{attrs:{"details":_vm.details}}),_c('formula-base',{attrs:{"details":_vm.details}}),_c('formula-add',{attrs:{"rowId":_vm.formulaId,"factoryId":_vm.factoryId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }